export default __webpack_public_path__ + "static/media/4-2_image21@2x.6b913bfc.png";